import {
    CHANG_ZYK_SEARCH_TEXT,
    ZYK_STORY_COUNT,
    ZYK_PICTURE_COUNT,
    ZYK_AUDIO_COUNT,
    ZYK_VIDEO_COUNT,
    ZYK_DOCUMENT_COUNT,
    CONTENT_PICTURE_COUNT
} from "../constants";

let initState = {
    searchText: "",
    onlyMe: false,
    tableKey: 1,
    doSearch:0,
    zykStoryCount:0,
    zykPictureCount: 0,
    zykAudioCount: 0,
    zykVideoCount: 0,
    zykDocumentCount: 0,
    contentPictureCount:0,

};

export default function zykReducer(state = initState, action) {
    switch (action.type) {
        case CHANG_ZYK_SEARCH_TEXT:
            return {
                ...state,
                searchText: action.searchText,
                onlyMe: action.onlyMe,
                tableKey: action.tableKey,
                doSearch:action.doSearch
            };
        case ZYK_STORY_COUNT:
            return {
                ...state,
                zykStoryCount: action.zykStoryCount,
            };
        case ZYK_PICTURE_COUNT:
            return {
                ...state,
                zykPictureCount: action.zykPictureCount,
            };
        case ZYK_AUDIO_COUNT:
            return {
                ...state,
                zykAudioCount: action.zykAudioCount,
            };
        case ZYK_VIDEO_COUNT:
            return {
                ...state,
                zykVideoCount: action.zykVideoCount,
            };
        case ZYK_DOCUMENT_COUNT:
            return {
                ...state,
                zykDocumentCount: action.zykDocumentCount,
            };
        case CONTENT_PICTURE_COUNT:
            return {
                ...state,
                contentPictureCount: action.zykContentPictureCount,
            };
        default:
            return state;
    }

}